export default {
  app: {
    title: 'Airatis Vision',
    logoutButton: 'Logout',
    adminButton: 'Admin',
    homeButton: 'Home',
  },
  errors: {
    error403: 'You do not have permission to access this page, please contact support',
    error404: 'The page you requested does not exist',
    error500: 'The application encountered an error, please retry later',
  },
  airports: {
    selectAirportMessage: 'Please select an airport',
    noAirportsMessage: `You don't have access to an airport, please contact support`,
  },
  detectionReports: {
    noDetectionMessage: 'There are no detections for this airport',
    noDetectionUnidentifiedMessage: 'There are no detections of unidentified aircraft for this airport yet',
    mainReportTitle: 'Detection reports',
    reportIdentifiedTitle: 'Detected on {{date}}\nAircraft registration : {{registration}} - Movement : {{movement}}',
    reportUnidentifiedTitle: 'Detected on {{date}}',
    downloadVideo: 'Download video',
    downloadImage: 'Download image',
    invoiceRequest: 'Request invoice',
    editReport: 'Edit',
    archiveReport: 'Archive',
    actionTitle: 'Options',
    cancelAction: 'Cancel',
    editReportMessage: 'Please modify current registration',
    reportIdentifiedMessage: 'Registration found with {{confidence}}% of confidence',
    reportUnidentifiedMessage: 'No registration was found with this aircraft detection',
    reportMessageWithPCLA: 'PCL A activated',
    reportMessageWithPCLB: 'PCL B activated',
    filterStartDate: 'Start date',
    filterEndDate: 'End date',
    previousPage: 'Previous page',
    nextPage: 'Next page',
    movementTypes: {
      TAKING_OFF: 'Takeoff',
      LANDING: 'Landing',
      LOW_PASS: 'Low pass',
      TOUCH_AND_GO: 'Touch and go',
      ROLLING_ON_TRACK: 'Rolling on runway',
      UNKNOWN: 'Unknown',
    },
    reportsLoading: 'More reports are loading',
    identifiedReportsTabTitle: 'Identified aircrafts',
    unidentifiedReportsTabTitle: 'Unidentified aircrafts',
    archivedReportsTabTitle: 'Archived reports',
    downloadOnGoingMessage: 'Video files download on going, please wait',
  },
}
